import { Box, Chip } from "@mui/material";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { zinc } from "./tokens";

type TagChipCellProps = {
  values: string[];
  activeFilter: string[];
};

export function TagChipCell({ values, activeFilter }: TagChipCellProps) {
  if (values.length === 0) return null;

  const filterActive = activeFilter.length > 0;

  const sortedValues = [...values].sort((a, b) => {
    const aMatches = filterActive && activeFilter.includes(a);
    const bMatches = filterActive && activeFilter.includes(b);
    if (aMatches !== bMatches) return aMatches ? -1 : 1;
    return a.localeCompare(b);
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        gap: 0.5,
        py: 0.25,
        overflowX: "auto",
        overflowY: "hidden",
        minWidth: 0,
        pl: "6px",
        pr: "6px",
        maskImage:
          "linear-gradient(to right, transparent, rgba(0,0,0,0.5) 3px, rgba(0,0,0,0.75) 6px, black 12px, black calc(100% - 12px), rgba(0,0,0,0.75) calc(100% - 6px), rgba(0,0,0,0.5) calc(100% - 3px), transparent)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent, rgba(0,0,0,0.5) 3px, rgba(0,0,0,0.75) 6px, black 12px, black calc(100% - 12px), rgba(0,0,0,0.75) calc(100% - 6px), rgba(0,0,0,0.5) calc(100% - 3px), transparent)",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {sortedValues.map((value) => {
        const filled = filterActive && activeFilter.includes(value);
        return (
          <Chip
            key={value}
            data-sb={TestIds.driverView.rowTagChip}
            label={value}
            size="small"
            variant={filled ? "filled" : "outlined"}
            sx={{
              flexShrink: 0,
              fontSize: "0.7rem",
              height: 20,
              color: filled ? undefined : zinc[400],
              borderColor: filled ? undefined : zinc[600],
            }}
          />
        );
      })}
    </Box>
  );
}
